import { Order } from '../../../types/interfaces';
import moment from 'moment';

/**
 * Скачивание счёта по заказу.
 *
 * Раньше тут стоял `axios.get(order.print_form, { responseType: 'blob' })`
 * с последующим созданием blob-ссылки. Это давало два разных артефакта:
 *
 *   1) CORS-блок. PDF лежит в `/media/orders/...` на бэке (на проде —
 *      раздаётся nginx'ом напрямую, а в Django CorsMiddleware
 *      применяется только к Django-handled роутам). XHR/fetch
 *      на cross-origin URL без CORS-заголовков — мгновенный provoke
 *      preflight + красный «(failed) CORS» в Network.
 *
 *   2) Service worker от CRA (`sw.js`) дополнительно интерцепил
 *      эти запросы и засорял лог дублирующими (failed) строчками.
 *
 * Решение: не качать через XHR/blob, а открывать ссылку через
 * обычный `<a>`-клик. Это **navigation**, к нему CORS не применяется,
 * service worker такие запросы тоже не трогает. PDF либо скачается
 * (если сервер вернёт `Content-Disposition: attachment`), либо
 * откроется во вкладке (тогда юзер может Ctrl+S).
 *
 * Минус — атрибут `download="<имя>"` для cross-origin URL браузер
 * игнорирует (это security: сайт не может задать чужому файлу имя).
 * Кастомное имя «Заказ-... от ДД.ММ.ГГГГ.pdf» формируется только
 * для same-origin случая (например, dev на одном хосте) — иначе
 * имя будет дефолтным от сервера. Если нужно кастомное имя везде —
 * это уже задача на отдельный бэк-эндпоинт-прокси с CORS.
 */
export const downloadBill = (event: React.MouseEvent, order: Order) => {
  event.stopPropagation();
  if (!order?.print_form) {
    return;
  }
  const link = document.createElement('a');
  link.href = order.print_form;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.setAttribute(
    'download',
    `Заказ-${order.name}-от ${moment(order.created_at).format('DD.MM.YYYY')}.pdf`
  );
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
};
